import React from "react";
import { useNavigate } from "react-router-dom";
import { IdeEnum } from "../../../../models/IdeEnum";
import classes from './DynamicScoreIndicators.module.css';
import CommunicationStudent from "../ActionsSubmission/CommunicationStudent";
import SubmissionsList from "./SubmissionsList/SubmissionsList";
import * as SubmissionStatus from "../../../lms-shared/models/SubmissionStatus";
import FeedbackAndGrade from "./FeedbackAndGrade/FeedbackAndGrade";

const DynamicScoreIndicators = ({ data, setData, allAssessments, sort, markAssessmentAsChecked }) => {

    const navigate = useNavigate();

    const changeAssessmentId = (assessment) => {
        if (assessment) {
            if (assessment.assessmentContentData.IdeId !== IdeEnum.MakeCode)
                navigate(`../${assessment.id}`)
            else
                window.location.href = `./${assessment.id}`;
        }
    }

    const nextAssessment = () => {
        const assessmentIndex = allAssessments.findIndex(a => a.id === data.id);
        if (assessmentIndex + 1 < allAssessments.length) {
            changeAssessmentId(allAssessments[assessmentIndex + 1]);
        }
        else {
            changeAssessmentId(allAssessments[0]);
        }
    }

    return (
        <div className={classes.DynamicScoreIndicators}>
            <div className={classes.SubmissionsList}>
                <SubmissionsList data={data} allAssessments={allAssessments} changeAssessmentId={changeAssessmentId} sort={sort} />
            </div>
            {data.submissionStatusId !== SubmissionStatus.started && data.submissionStatusId !== SubmissionStatus.notStarted ?
                <div className={classes.FeedbackAndGrade}>
                    <FeedbackAndGrade data={data} setData={setData} nextAssessment={allAssessments.length > 1 ? nextAssessment : null} markAssessmentAsChecked={markAssessmentAsChecked} />
                </div> : ''}
            <div className={data.submissionStatusId !== SubmissionStatus.started && data.submissionStatusId !== SubmissionStatus.notStarted ? classes.CommunicationStudent : classes.FullCommunicationStudent}>
                <CommunicationStudent submissionDetails={data} nextAssessment={allAssessments.length > 1 ? nextAssessment : null} markAssessmentAsChecked={markAssessmentAsChecked} />
            </div>
        </div>
    )
}

export default DynamicScoreIndicators;